<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card outlined>
          <!-- Titre principal -->
          <v-card-title>
            <h1 class="text-h5" v-if="this.$store.state.loggedUser.job == 'RESEARCHER'">
              Création d'une nouvelle étude alimentaire
            </h1>
            <h1 class="text-h5" v-else-if="this.$store.state.loggedUser.job == 'CONSUMER'">
              Création d'un nouveau challenge
            </h1>
            <h1 class="text-h5" v-else>Création d'une nouvelle action</h1>
          </v-card-title>

          <!-- Formulaire -->
          <v-form @submit.prevent="submitForm" ref="form">
            <v-card-text>
              <!-- Titre -->
              <v-text-field v-model="form.title" label="Titre" outlined dense required></v-text-field>

              <!-- <v-checkbox
                v-model="form."
                :rules="[(v) => !!v || 'You must agree to continue!']"
                label="Do you agree?"
                required
              ></v-checkbox> -->

              <!-- Étude -->
              <v-select
                v-model="selectedConcerns"
                :items="concerns"
                item-value="id"
                item-text="title"
                label="Problématiques"
                outlined
                dense
                required
              ></v-select>
              <v-select
                v-model="form.study"
                :items="studies"
                item-value="id"
                item-text="title"
                label="Solution"
                outlined
                dense
                required
              ></v-select>

              <!-- Cantine -->
              <v-select
                v-model="form.canteen"
                :items="canteens"
                item-value="id"
                item-text="name"
                label="Cantine"
                outlined
                dense
                required
              ></v-select>

              <v-select
                v-model="form.target"
                :items="getTargetOptions()"
                item-text="label"
                item-value="value"
                label="Choisissez une cible"
                outlined
                dense
              />
            </v-card-text>

            <!-- Boutons -->
            <v-card-actions class="justify-end">
              <v-btn text color="primary" @click="stopCreation">Annuler</v-btn>
              <v-btn color="primary" type="submit" elevation="2">Créer</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: "",
        study: null,
        canteen: null,
      },
      studies: [],
      canteens: [],
      selectedConcerns: null,
      concerns: [],
      startMenu: false,
      endMenu: false,
    }
  },
  methods: {
    getTargetOptions() {
      return [
        { value: "CANTEEN", label: "Restaurateur" },
        { value: "CLIENT", label: "Convive" },
      ]
    },
    onIssueChange() {
      console.log("selected", this.selectedConcerns)
      // const params = this.selectedConcerns
      // console.log("params", params)
      this.$store
        .dispatch("fetchAllStudySurveys", { params: this.selectedConcerns })
        .then((response) => {
          console.log("test", response)
          this.studies = response
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    fetchCurrentPage() {
      console.log("Fetching current page...")
      this.$store
        .dispatch("fetchAllConcerns")
        .then((response) => {
          this.concerns = response
          console.log("Fetched concerns", this.concerns, response)
          // this.onIssueChange()
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
      this.$store
        .dispatch("fetchCanteenSummary")
        .then((response) => {
          this.canteens = response.results
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },

    submitForm() {
      console.log("Form data", this.form)

      this.$store
        .dispatch("CreateAction", { payload: this.form })
        .then(() => {
          console.log("Action created successfully")
          this.$router.push({ name: "ActionPlan" })
        })
        .catch((error) => {
          console.error("Error during action creation:", error)
          this.$store.dispatch("notifyServerError")
        })
    },

    clearForm() {
      this.form = {
        title: "",
        start: "",
        end: "",
        study: null,
        canteen: null,
      }
      this.startMenu = false
      this.endMenu = false
    },

    stopCreation() {
      this.clearForm()
      this.$router.push({ name: "ActionPlan" })
    },
  },

  watch: {
    $route() {
      this.fetchCurrentPage()
    },
    selectedConcerns(newValue) {
      this.onIssueChange(newValue)
    },
  },
  mounted() {
    // this.fetchConcerns()
    this.fetchCurrentPage()
  },
}
</script>

<style scoped>
.v-container {
  max-width: 600px;
  margin: auto;
}

.v-card-title {
  justify-content: center;
  font-weight: bold;
}

.v-card-actions {
  padding: 16px;
}
</style>
